import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Sidenav = () => {
    const [isToggled, setIsToggled] = useState(false);

    const handleSidebarToggle = () => {
        setIsToggled(!isToggled);
    };

    return (
        <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${isToggled ? 'toggled' : ''}`} id="accordionSidebar">
            <Link to="/admin/dashboard" className="sidebar-brand d-flex align-items-center justify-content-center">
                <div className="sidebar-brand-icon rotate-n-0">
                    <i className="fas fa-laptop"></i>
                </div>
                <div className="sidebar-brand-text mx-3">SQRTECH</div>
            </Link>
            <hr className="sidebar-divider my-0" />
            <li className="nav-item active">
                <Link to="/admin/dashboard" className="nav-link">
                    <i className="fas fa-fw fa-tachometer-alt"></i>
                    <span>Dashboard</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/admin/dashboard/users" className="nav-link">
                    <i className="fas fa-fw fa-users"></i>
                    <span>Users</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/admin/dashboard/products" className="nav-link">
                    <i className="fas fa-fw fa-box"></i>
                    <span>Products</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/admin/dashboard/orders" className="nav-link">
                    <i className="fas fa-fw fa-box"></i>
                    <span>Orders</span>
                </Link>
            </li>
            <hr className="sidebar-divider my-0" />
            <div className="sidebar-heading">Interface</div>

            {/* Example of Bootstrap 5 Collapse */}
            <li className="nav-item">
                <button className="nav-link collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseComponents">
                    <i className="fas fa-fw fa-cog"></i>
                    <span>Components</span>
                </button>
                <div id="collapseComponents" className="collapse">
                    <div className="bg-white py-2 collapse-inner rounded">
                        <h6 className="collapse-header">Custom Components:</h6>
                        <Link className="collapse-item" to="/admin/buttons">Buttons</Link>
                        <Link className="collapse-item" to="/admin/cards">Cards</Link>
                    </div>
                </div>
            </li>

            <hr className="sidebar-divider d-none d-md-block" />
            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle" onClick={handleSidebarToggle}></button>
            </div>
        </ul>
    );
};

export default Sidenav;
